import { House, Clock, Star, ShieldCheck } from "lucide-react";
const stats = [{
  icon: House,
  value: "10+",
  label: "Specialisten"
}, {
  icon: Clock,
  value: "5",
  label: "Expertises"
}, {
  icon: Star,
  value: "1",
  label: "Gezamenlijk Doel"
}, {
  icon: ShieldCheck,
  value: "100%",
  label: "Resultaatgericht"
}];
export default function Valuesmetrics() {
  return <section data-section-id="260676" id="valuesmetrics" className="bg-background text-foreground py-10 border-y border-border backdrop-blur-xl">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center">
          {stats.map((stat, i) => {
          const Icon = stat.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center justify-center space-y-3 p-4 rounded-lg transition-all duration-300 hover:bg-accent/50">
                <Icon className="w-6 h-6 text-primary" aria-hidden="true" />
                <div className="flex flex-col space-y-1">
                  <span className="text-4xl md:text-5xl font-bold font-default text-primary tracking-tighter">
                    {stat.value}
                  </span>
                  <span className="text-sm font-default text-muted-foreground uppercase tracking-widest">
                    {stat.label}
                  </span>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}